import React from "react";
import { motion, useAnimation, useInView } from "framer-motion";
import { useRef, useEffect } from "react";
import { useLocation } from "@gatsbyjs/reach-router";

const isBot = typeof navigator !== "undefined" && /bot|googlebot|crawl|spider/i.test(navigator.userAgent);

const TextReveal = ({
	children,
	type,
	xAxisValue,
	delayTime,
	revealValue,
	duration,
	amount,
}) => {
	const ref = useRef(null);
	const isInView = useInView(ref, { once: true, amount });
	const location = useLocation();
	const controls = useAnimation();

	const excludedSlugs = ["/services/data-engineering-consulting-services/"];
	const isExcludedSlug = excludedSlugs.includes(location.pathname);

	useEffect(() => {
		if (isInView) {
			controls.start("show");
		}
	}, [controls, isInView]);

	const onAnimationStart = () => {
		ref.current.style.pointerEvents = "none";
	};

	const onAnimationComplete = () => {
		ref.current.style.pointerEvents = "auto";
	};

	if (isBot) {
		return <div ref={ref}>{children}</div>;
	}

	if (isExcludedSlug) {
		return <div ref={ref}>{children}</div>;
	}

	return (
		<div>
			<motion.div
				ref={ref}
				variants={{
					hidden: {
						opacity: 0,
						transform: `translate3d(0, ${revealValue}, 0)`,
						width: "100%",
						height: "100%",
					},
					show: {
						opacity: 1,
						transform: "translate3d(0, 0, 0)",
						width: "100%",
						height: "100%",
					},
				}}
				initial="hidden"
				animate={controls}
				transition={{ duration: duration, delay: delayTime, ease: "circIn" }}
				onAnimationStart={onAnimationStart}
				onAnimationComplete={onAnimationComplete}
			>
				{children}
			</motion.div>
		</div>
	);
};

export default TextReveal;
